import merge from 'lodash/merge';

export default class ReservationUpdateHelper {
  constructor(reservation, reservationUpdate) {
    this.reservation = reservation;
    this.reservationUpdate = reservationUpdate;
    this.paymentId = null;
    this.paymentMethodId = null;
    this.paymentIntentId = null;
    return this;
  }

  haveToPayExtra() {
    var price = this.differencePrice();
    if (price) {
      return price > 0 && this.isOnlinePayment();
    } else {
      return false;
    }
  }

  isNoMadeAnyChange() {
    var sameAdults = this.reservation.adults === this.reservationUpdate.adults;
    var sameChildren = this.reservation.children === this.reservationUpdate.children;
    var sameAddress = this.reservation.address_phrase === this.reservationUpdate.address.phrase;
    var sameKidsSafety = true;
    if (this.reservation.reservation_seats) {
      for (var i = 0; i < this.reservation.reservation_seats.length; i++) {
        var seat = this.reservation.reservation_seats[i];
        if (this.getKidsSafety(seat.seat.name) !== seat.amount) {
          sameKidsSafety = false;
          break;
        }
      }
    }
    return sameAdults && sameChildren && sameAddress && sameKidsSafety;
  }

  isOnlinePayment() {
    return !this.reservation.payment_to_driver;
  }

  differencePrice() {
    if (this.reservationUpdate.price) {
      return parseInt(this.reservationUpdate.price)
        - parseInt(this.reservation.price);
    } else {
      return null;
    }
  }

  differenceLabel() {
    var price = this.differencePrice();
    if (price) {
      if (price > 0) {
        return '+' + price;
      } else {
        return price;
      }
    } else {
      return '--';
    }
  }

  setPaymentId(value) {
    this.paymentId = value;
  }

  setPaymentMethodId(value) {
    this.paymentMethodId = value;
  }

  setPaymentIntentId(value) {
    this.paymentIntentId = value;
  }

  getKidsSafety(key = null) {
    //names must be the same as constants in Seat model
    var ks = this.reservationUpdate.kidsSafety;
    var data = {
      'no_need_car_seat': ks.noNeedCarSeat,
      'cradle': ks.cradle,
      'seat_with_seat_belts': ks.seatWithSeatBelts,
      'seat_without_seat_belts': ks.seatWithoutSeatBelts,
      'car_seat_pad': ks.carSeatPad
    };
    if (key) {
      var lowerKey = key.toLowerCase();
      return data[lowerKey];
    } else {
      return data;
    }
  }

  requestParams() {
    var busStop = null;
    if (!this.reservationUpdate.address.selectedObject.g) {
      busStop = this.reservationUpdate.address.selectedObject.value;
    }
    return {
      data: {
        id: this.reservationUpdate.id,
        price: this.reservationUpdate.price,
        adults: this.reservationUpdate.adults,
        children: this.reservationUpdate.children,
        kids_safety: this.getKidsSafety(),
        is_bus_stop: !this.reservationUpdate.address.selectedObject.g,
        bus_stop: busStop,
        lat: this.reservationUpdate.address.lat,
        lng: this.reservationUpdate.address.lng,
        name: this.reservationUpdate.address.selectedObject.label,
        postcode: this.reservationUpdate.address.postcode,
      }
    };
  }

  requestParamsWithPayment(supplementState) {
    var params = this.requestParams();
    return merge(params, {
      data: {
        saveCard: supplementState.saveCard,
        paymentId: this.paymentId,
        paymentMethodId: this.paymentMethodId,
        paymentIntentId: this.paymentIntentId,
        selectedCardId: this.reservationUpdate.selectedCardId,
        paymentDescription: supplementState.paymentDescription
      }
    })
  }
}
